import { render, staticRenderFns } from "./ZCCityPublic.vue?vue&type=template&id=15562ae9&scoped=true&"
import script from "./ZCCityPublic.vue?vue&type=script&lang=ts&"
export * from "./ZCCityPublic.vue?vue&type=script&lang=ts&"
import style0 from "./ZCCityPublic.vue?vue&type=style&index=0&id=15562ae9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15562ae9",
  null
  
)

export default component.exports